import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Pagination,
  TablePagination,
  FormLabel,
} from "@mui/material";
import { Delete, Add } from "@mui/icons-material";
import api from "../../API/api";
import { toast } from "react-toastify";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [newImages, setNewImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isUploading , setIsUploading] = useState(false)
  // const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [padingate, setpadingate] = useState([]);

  // Fetch images on component mount
  useEffect(() => {
    fetchImages(currentPage);
  }, [currentPage, rowsPerPage]);

  // Fetch images from the API
  const fetchImages = async () => {
    setLoading(true);
    try {
      const response = await api.fetchGallery(currentPage, rowsPerPage);
      // console.log(response);

      setImages(response.data.data);
      setpadingate(response.data);
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle file change for multiple files
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 6) {
      alert("Limit the upload to 6, to safely upload to server");
      return;
    }
    const updatedImages = files.map((file, index) => ({
      id: index,
      file,
      title: "",
      year: "",
    }));
    setNewImages(updatedImages);
  };

  // Handle input changes for title and year
  const handleInputChange = (index, field, value) => {
    const updatedImages = [...newImages];
    updatedImages[index][field] = value;
    setNewImages(updatedImages);
  };

  // Submit handler
  const addImage = async (e) => {
    setIsUploading(true);
    // toast.success('dsad')
    e.preventDefault();
    const formData = new FormData();
    console.log(newImages, "image");
    
    newImages.forEach((image, index) => {
      formData.append(`file[]`, image.file);
      formData.append(`title[]`, image.title);
      formData.append(`year[]`, image.year);
    });
    try {
      const response = await api.addGalleryImage(formData);
      if (response.data.status === 200) {
        toast.success("Images uploaded successfully");
        setShowAddModal(false);
        setNewImages([]);
        // Refresh gallery or update state
      }
      setIsUploading(false);
    } catch (error) {
      console.error("Error uploading images:", error);
      // if (error.response.status === 422) {
      const errors = error.response.data.errors;

      // Loop through each error and display it
      Object.entries(errors).forEach(([field, messages]) => {
        // Extract the image index from the field name (e.g., "file.0" -> "Image 1")
        const imageIndex = field.split(".")[1];

        // Format the error message
        const errorMessage = `Image ${
          parseInt(imageIndex) + 1
        }: ${messages.join(", ")}`;

        // Show the error message
        toast.error(errorMessage);
      });
      // }
      toast.error("Failed to upload images");
    }
  };

  // Confirm delete
  const confirmDelete = (image) => {
    setSelectedImage(image);
    setShowDeleteModal(true);
  };

  // Delete image
  const deleteImagesModal = async () => {
    try {
      //   await axios.delete(`/api/gallery/${selectedImage.id}`);
      let response = await api.deleteGalleryImage(selectedImage.id);
      console.log(response, "check repsonse delete");
      if (response.data.status) {
        toast.success(`${response.data.message}`);
        setImages(images.filter((img) => img.id !== selectedImage.id));
        setShowDeleteModal(false);
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  // const handlePageChange = (event, page) => {
  //   setCurrentPage(page);
  //   fetchImages(page);
  // };
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    // setPage(0);
  };
  // Add delete functionality
  const deleteImage = (index) => {
    const updatedImages = newImages.filter((_, i) => i !== index);
    setNewImages(updatedImages);
  };

  // Modal style
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Header and Add Button */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <Typography variant="h4" component="h2">
          Gallery Images
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => setShowAddModal(true)}
        >
          Add New Images
        </Button>
      </div>

      {/* Gallery Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Title</TableCell>
              {/* <TableCell>Description</TableCell> */}
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : (
              images.map((image) => (
                <TableRow key={image.id} hover>
                  <TableCell>
                    <img
                      src={image.url}
                      alt={image.title}
                      style={{
                        width: 80,
                        height: 80,
                        objectFit: "cover",
                        borderRadius: 4,
                      }}
                    />
                  </TableCell>
                  <TableCell>{image.title}</TableCell>
                  {/* <TableCell>{image.description}</TableCell> */}
                  <TableCell align="right">
                    <IconButton
                      color="error"
                      onClick={() => confirmDelete(image)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="d-flex justify-content-center mt-4">
        {/* <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          showFirstButton
          showLastButton
        /> */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
          component="div"
          count={padingate.total}
          rowsPerPage={padingate.per_page}
          page={padingate.current_page - 1}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          labelRowsPerPage="Rows per page"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} of ${count}`
          }
          labelId="demo-simple-select-label"
          nextIconButtonText="Next Page"
          backIconButtonText="Previous Page"
          onPageButtonText="Page"
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
      {/* Add Image Modal */}
      <Modal open={showAddModal} onClose={() => setShowAddModal(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h3" mb={3}>
            Add New Images
          </Typography>
          <Box
            className="overflow-y-scroll "
            style={{ minheight: "20vh", height: "80vh" }}
          >
            <form onSubmit={addImage}>
              <Box>
                <FormLabel>Upload MUltiple Images here</FormLabel>
                <Box className="flex flex-col">
                  <Typography variant="caption">
                    *maximum 6 images per upload is required for stable uplaod
                    process & images size should be less then 1.8mb
                  </Typography>
                  <Box>
                    <input
                      type="file"
                      onChange={handleFileChange}
                      multiple
                      required
                      style={{ margin: "16px 0" }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box className="row">
                {newImages.map((image, index) => (
                  <Box
                    key={image.id}
                    className="col-md-4 "
                    style={{
                      marginBottom: "16px",
                      border: "1px solid #ddd",
                      padding: "16px",
                      borderRadius: "8px",
                    }}
                  >
                    {/* Image Preview */}
                    <div style={{ marginBottom: "16px", textAlign: "center" }}>
                      <img
                        src={URL.createObjectURL(image.file)}
                        alt={`Preview ${index + 1}`}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "200px",
                          borderRadius: "8px",
                        }}
                      />
                    </div>

                    {/* Title and Year Inputs */}
                    <TextField
                      label="Title"
                      fullWidth
                      value={image.title}
                      onChange={(e) =>
                        handleInputChange(index, "title", e.target.value)
                      }
                      margin="normal"
                      required
                    />
                    <TextField
                      label="Year"
                      fullWidth
                      required
                      value={image.year}
                      onChange={(e) =>
                        handleInputChange(index, "year", e.target.value)
                      }
                      margin="normal"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                    />

                    {/* Delete Button */}
                    <div style={{ textAlign: "right", marginTop: "8px" }}>
                      <Button
                        variant="outlined"
                        color="error"
                        startIcon={<Delete />}
                        onClick={() => deleteImage(index)}
                      >
                        Remove
                      </Button>
                    </div>
                  </Box>
                ))}
              </Box>
              {newImages.length !== 0 && (
                <div className="d-flex justify-content-end gap-2 mt-3">
                  <Button
                    variant="outlined"
                    onClick={() => setShowAddModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" color="primary" disabled={isUploading}>
                    {
                      isUploading ? 'Uploading Please wait ' : 'Upload Images'
                    }
                    
                  </Button>
                </div>
              )}
            </form>
          </Box>
        </Box>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h3" mb={3}>
            Confirm Delete
          </Typography>
          <Typography mb={4}>
            Are you sure you want to delete this image?
          </Typography>
          <div className="d-flex justify-content-end gap-2">
            <Button
              variant="outlined"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={deleteImagesModal}
            >
              Delete
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Gallery;
